import { render, staticRenderFns } from "./Recipes_section.vue?vue&type=template&id=498b5d96&scoped=true&"
import script from "./Recipes_section.vue?vue&type=script&lang=js&"
export * from "./Recipes_section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498b5d96",
  null
  
)

export default component.exports